import * as React from 'react';
import {Shop} from 'interfaces';
import {Button, Flex, Section} from 'components/UIKit';
import {ListingCards} from 'components/Marketplace/ListingCards';

export interface ListingLayoutProps {
  heading: string;
  subhead?: string;
  shops: Shop[];
  cta: string;
  ctaPath: string;
  className?: string;
}

export function ListingLayout({
  heading,
  subhead,
  shops,
  cta,
  ctaPath,
  className,
}: ListingLayoutProps) {
  return (
    <Section
      heading={heading}
      subhead={subhead}
      headingProps={{align: 'center'}}
      subheadProps={{align: 'center'}}
      headerSpacing="x-small"
      className={className}
    >
      <Section spacing="small" resetPaddingTop fullWidth>
        <ListingCards shops={shops} />
      </Section>
      <Flex justifyContent="center">
        <Button url={ctaPath} label={cta} secondary />
      </Flex>
    </Section>
  );
}
